import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

// mui components
import { Stack, Tabs, Tab, InputLabel } from "@mui/material";

// custom components
import EmptyTextContainer from "../../empty-text-container";
import { TabPanel } from "../../tab-panel";
import RequiredError from "../../required-error";
import Heading6 from "../../typography/heading-06";
import EligibleFilter from "../../loan-form-card/eligible-filter";
import IneligibleFilter from "../../loan-form-card/ineligible-filter";
import TemporaryDrawer from "../../temporary-drawer";
import PrimaryButton from "../../buttons/primary-button";
import Heading5 from "../../typography/heading-05";
import Body3 from "../../typography/body-03";
import Body2 from "../../typography/body-02";
import SecondarySelect from "../../custom-select/secondary-select";

// api slices
import { useGetLoanMutation } from "../../../features/get-loan-data/getLoanApiSlice";
import { useGetEligibleProductsMutation } from "../../../features/get-eligible-products/getEligibleProductsApiSlice";
import { useGetEligibleProductDetailsMutation } from "../../../features/get-eligible-product-details/getEligibleProductDetailsApiSlice";
import { useGetIneligibleProductsMutation } from "../../../features/get-ineligible-products/getIneligibleProductsApiSlice";
import { useUpdateLoanWithProductMutation } from "../../../features/update-loan-with-product/updateLoanWithProductApiSlice";
import { useFieldMutation } from "../../../features/field-values/fieldValueApiSlice";
import { useCreateOBLockRequestMutation } from "../../../features/create-OB-lock-request/createOBLockRequestApiSlice";
import { useUpdateFieldsMutation } from "../../../features/update-fields/updateFieldsApiSlice";

// redux slice
import {
	selectUserDetails,
	selectSelectedOrganization,
	selectOrganizationName,
} from "../../../features/auth/authSlice";
import { selectImpersonatedUser } from "../../../features/admin/impersonated-user/impersonatedUserSlice";

// custom modal
import LoaderTextModal from "../../modal/loader-text-modal";
import SuccessModal from "../../modal/success-modal";
import CommanErrorModal from "../../modal/common-error-modal";
import ErrorModal from "../../modal/error-modal";
import PricingModal from "../../modal/pricing-modal";
import ProcessingModal from "../../modal/processing-modal";
import LoaderModal from "../../modal/loader-modal";

//hooks
import { useErrorMessages } from "../../../utils/error-messages.constants";

//utils
import {
	BROKER_ADMIN,
	LOAN_CHANNEL_CONSTANTS,
	TPO_SECONDARY,
} from "../../../utils/common-constants";
import {
	selectedUserWithAccessLevel,
	selectedUserWithLoanChannel,
} from "../../../utils/common-helpers";
import { compensationPlanOptions } from "../../../utils/select-options";

// custom styles
import styles from "./index.module.scss";

const LoanPricingCard = (
	{
		loanGuid,
		setIsPriceLoanDisabled,
		handleTabChange,
		getFieldValuesOnLoanSummary,
		goToDefaultView,
	},
	ref
) => {
	const params = useParams();

	// Expose the childMethod using a ref
	React.useImperativeHandle(ref, () => ({
		handleSubmitApplication: () => handleSubmitApplication(),
	}));

	console.log("50 loan id:", loanGuid);

	const [tabValue, setTabValue] = useState(0);

	const handleChangeTab = (event, newValue) => {
		setTabValue(newValue);
	};

	function a11yProps(index) {
		return {
			id: `simple-tab-${index}`,
			"aria-controls": `simple-tabpanel-${index}`,
		};
	}

	const [getLoan, { isLoading: isGettingLoan }] = useGetLoanMutation();
	const [field] = useFieldMutation();
	const [updateFields, { isLoading: isUpdatingFields }] =
		useUpdateFieldsMutation();
	const [getEligibleProducts, { isLoading: isGettingEligibleProducts }] =
		useGetEligibleProductsMutation();
	const [
		getEligibleProductDetails,
		{ isLoading: isGettingEligibleProductDetails },
	] = useGetEligibleProductDetailsMutation();
	const [getIneligibleProducts, { isLoading: isGettingIneligibleProducts }] =
		useGetIneligibleProductsMutation();

	const [updateLoanWithProduct, { isLoading: isUpdatingLoanWithProduct }] =
		useUpdateLoanWithProductMutation();

	const [createOBLockRequest, { isLoading: isCreatingOBLockRequest }] =
		useCreateOBLockRequestMutation();

	console.log("23 params:", params);
	console.log("23 loan id:", loanGuid);

	const [loanData, setLoanData] = useState({});
	const [eligibleProducts, setEligibleProducts] = useState([]);
	const [expandedProduct, setExpandedProduct] = useState("");
	const [eligibleProductDetails, setEligibleProductDetails] = useState({});
	const [selectedRow, setSelectedRow] = useState({});
	const [selectedProduct, setSelectedProduct] = useState({});
	console.log("40 selected product:", selectedProduct);
	console.log("40 selected eligible sub product:", selectedRow);

	const [ineligibleProducts, setIneligibleProducts] = useState([]);

	const [drawerData, setDrawerData] = useState({});
	const [drawerType, setDrawerType] = useState("");
	const [drawerOpen, setDrawerOpen] = useState({});

	const [loanProgram, setLoanProgram] = useState("");
	const [loanEmail, setLoanEmail] = useState("");
	const [orgLoanChannel, setOrgLoanChannel] = useState("");

	const [compensationPlan, setCompensationPlan] = useState("");

	const userDetails = useSelector(selectUserDetails);
	const impersonatedUser = useSelector(selectImpersonatedUser);
	const selectedOrganization = useSelector(selectSelectedOrganization);
	const organizationName = useSelector(selectOrganizationName);
	const currentOrganization = selectedOrganization || organizationName;

	const getLastName = (fullName) => {
		if (!fullName) return null;
		const parts = fullName.trim().split(" ");
		return parts[parts.length - 1];
	};

	const handleOpenDrawer = () => {
		setDrawerOpen({
			right: true,
		});
	};

	const handleCloseDrawer = () => {
		setDrawerOpen({
			right: false,
		});
	};

	console.log("100 all products:", eligibleProducts);
	console.log("100 expanded id:", expandedProduct);
	console.log("100 product details:", eligibleProductDetails);

	const toggleDrawer = (event, drawerType, rowData) => {
		if (drawerType !== undefined && drawerType !== "") {
			console.log("eligible products:", eligibleProducts);
			console.log("expanded product:", expandedProduct);

			const parentProductDetails = eligibleProducts?.data?.products?.filter(
				(product) => product?.productId === expandedProduct
			);

			console.log("parent product details:", parentProductDetails);

			setDrawerData({
				loanData: loanData,
				parentProductDetails: parentProductDetails[0],
				productDetails: eligibleProductDetails,
				rowData: rowData,
			});
			setDrawerType(drawerType);
			handleOpenDrawer();
		} else {
			setDrawerType("");
			handleCloseDrawer();
		}
	};

	const [processingText, setProcessingText] = useState("");
	const [processingModalVisible, setProcessingModalVisible] = useState(false);

	const handleOpenProcessingModal = () => {
		setProcessingModalVisible(true);
	};

	const handleCloseProcessingModal = () => {
		setProcessingModalVisible(false);
	};

	const [successText, setSuccessText] = useState("");
	const [successModalVisible, setSuccessModalVisible] = useState(false);

	const handleOpenSuccessModal = () => {
		setSuccessModalVisible(true);
	};

	const handleCloseSuccessModal = () => {
		setSuccessModalVisible(false);
		getFieldValuesOnLoanSummary();
		goToDefaultView();
	};

	const [errorText, setErrorText] = useState("");
	const [errorHeadingText, setHeadingErrorText] = useState("");
	const [errorModalVisible, setErrorModalVisible] = useState(false);
	const [commonErrorData, setCommonErrorData] = useState(null);
	const [commonErrorModalVisible, setCommonErrorModalVisible] = useState(false);

	const { getErrorMessage } = useErrorMessages();

	const handleOpenErrorModal = () => {
		setErrorModalVisible(true);
	};
	const handleCloseErrorModal = () => {
		setErrorModalVisible(false);
		goToDefaultView();
	};

	const handleOpenCommonErrorModal = useCallback(
		(errorKey, errData) => {
			setCommonErrorData(getErrorMessage(errorKey, errData));
			setCommonErrorModalVisible(true);
		},
		[getErrorMessage]
	);

	const handleCloseCommonErrorModal = () => {
		setCommonErrorModalVisible(false);
		setCommonErrorData(null);
	};

	const [pricingModal, setPricingModal] = useState(false);

	const handleOpenPricingModal = () => {
		setPricingModal(true);
	};

	const handleClosePricingModal = () => {
		setPricingModal(false);
	};

	const handleSubmitPricingModal = async () => {
		console.log("100 eligible products:", eligibleProducts);
		console.log("100 expanded product:", expandedProduct);
		console.log("85 selected sub products", selectedRow);

		var formData = new FormData();
		formData.append("ob_loan_id", eligibleProducts?.data?.ob_loan_id);
		formData.append(
			"ob_business_channel_id",
			eligibleProducts?.data?.ob_business_channel_id
		);
		formData.append(
			"ob_originator_id",
			eligibleProducts?.data?.ob_originator_id
		);
		const lastName = getLastName(loanData?.titleHolderName1);

		formData.append("product_id", expandedProduct);
		formData.append("search_id", eligibleProducts?.data?.searchId);
		formData.append("rate", selectedRow?.rate);
		formData.append("price", selectedRow?.price);
		formData.append("lock_period", selectedRow?.lockPeriod);
		formData.append("loanguid", loanData?.encompassId);
		formData.append("borrower_last_name", lastName);
		formData.append(
			"submitted_by",
			userDetails.first_name + " " + userDetails.last_name
		);
		formData.append("company_name", currentOrganization);
		formData.append("email", userDetails.email);
		formData.append("encompass_loan_number", loanData.loanNumber);
		formData.append("source_area","Request Lock");
		// dispatch API and open modal if successful
		try {
			const updatedLoanWithProduct = await updateLoanWithProduct({
				formData,
			}).unwrap();
			console.log("125 updated loan with product:", updatedLoanWithProduct);

			if (updatedLoanWithProduct?.message?.toLowerCase()?.includes("success")) {
				try {
					const createOBLockRequestData = await createOBLockRequest({
						formData,
					}).unwrap();

					if (
						createOBLockRequestData?.message?.toLowerCase()?.includes("success")
					) {
						// add logic if required
						handleOpenSuccessModal();
						setSuccessText(
							`Your lock request has been submitted to Logan Finance.`
						);
					}
				} catch (err) {
					console.log(
						"LoanPricingCard:handleSubmitPricingModal:createOBLockRequest:err",
						err
					);

					handleClosePricingModal();

					// Use the specific error message from the API response
					setCommonErrorData({
						code: "OB-LOCK-008",
						title: "Lock request failed",
						error_response: err?.data?.data,
						message:
							err?.data?.data?.errors ||
							err?.data?.message ||
							"Lock request could not be processed",
					});
					setCommonErrorModalVisible(true);

					return;
				}
			} else {
				handleClosePricingModal();
				handleOpenCommonErrorModal("PRODUCT_UPDATE_FAILED_ENCOMPASS");
			}
		} catch (err) {
			console.log("290 error catch:", err);

			handleClosePricingModal();
			handleOpenCommonErrorModal("REQUEST_LOCK_ERROR", err?.data);
		}
	};

	const [error, setError] = useState("");

	const getIneligibleProductList = async ({
		ob_business_channel_id,
		ob_originator_id,
		ob_loan_id,
		searchId,
	}) => {
		try {
			console.log("200 eligibleProducts:", eligibleProducts);

			const ineligibleProductList = await getIneligibleProducts({
				ob_business_channel_id,
				ob_originator_id,
				ob_loan_id,
				searchId,
				selectedOrganization: currentOrganization,
				userDetails: userDetails,
			}).unwrap();

			console.log(
				"120 ineligible products:",
				ineligibleProductList?.data?.ineligibleProducts
			);
			setIneligibleProducts(ineligibleProductList?.data?.ineligibleProducts);
		} catch (err) {
			console.log("270 error:", err);
			handleOpenCommonErrorModal("INELIGIBLE_PRODUCTS_UNAVAILABLE", err?.data);
		}
	};

	const getEligibleProductList = async () => {
		console.log("275 loan id:", loanGuid);

		try {
			const loanDetails = await getLoan({
				loanid: loanGuid,
				selectedOrganization: currentOrganization,
				userDetails: userDetails,
			}).unwrap();

			console.log("120 loan data:", loanDetails?.response);
			console.log("120 loan number:", loanDetails?.response?.loanNumber);

			setLoanData(loanDetails?.response);

			let propertyType;

			let isPropertyNotLocatedInProject =
				loanDetails?.response?.notInProjectIndicator;

			if (isPropertyNotLocatedInProject) {
				// Single Family or 2-4 Unit Property or 5-8 Unit Residential or 5-8 Unit Mixed Use
				propertyType = "SingleFamily";
			} else {
				propertyType = "";
			}

			console.log("360 property type:", propertyType);

			console.log("450 userDetails:", userDetails);
			console.log("450 impersonatedUser:", impersonatedUser);
			console.log(
				"450 selected:",
				selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.loan_channel
			);

			console.log(
				"400 selected email:",
				selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.email
			);

			let loanChannel;
			let email;
			let regex = /\(([^)]+)\)/;

			if (
				((impersonatedUser?.email === undefined ||
					impersonatedUser?.email === null) &&
					userDetails?.user_roles?.includes("admin") === true) ||
				userDetails?.user_roles?.includes("manager") ||
				userDetails?.user_roles?.includes("AM") ||
				userDetails?.user_roles?.includes("executive") ||
				userDetails?.user_roles?.includes("AE") ||
				userDetails?.user_roles?.includes("PA") ||
				userDetails?.user_roles?.includes("assistant")
			) {
				console.log("500 email:", loanEmail);
				console.log("500 org loan channel:", orgLoanChannel);
				console.log("500 loan channel:", orgLoanChannel?.match(regex)?.[1]);
				loanChannel = orgLoanChannel?.match(regex)?.[1];
				email = loanEmail;
			} else {
				loanChannel = selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.loan_channel;
				email = selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.email;
			}

			var formData = new FormData();
			formData.append("encompass_loan_guid", loanGuid);
			formData.append(
				"encompass_loan_number",
				loanDetails?.response?.loanNumber
			);
			formData.append("propertyType", propertyType);
			formData.append("loan_channel", loanChannel?.toUpperCase());
			formData.append("broker_email", email);
			formData.append("compensation_paid", compensationPlan);

			const eligibleProductList = await getEligibleProducts({
				formData,
				selectedOrganization: currentOrganization,
				userDetails: userDetails,
			}).unwrap();

			console.log("120 eligible products:", eligibleProductList);

			if (eligibleProductList?.status?.toLowerCase()?.includes("success")) {
				const allProducts = eligibleProductList?.data?.products || [];
				const filteredEligibleProducts = loanProgram
					? allProducts.filter((product) => product.productName === loanProgram)
					: allProducts;
				const tempEligibleProductList = {
					...eligibleProductList,
					data: {
						...eligibleProductList?.data,
						products: [...filteredEligibleProducts],
					},
				};
				console.log(
					"LoanPricingCard:getEligibleProductList:tempEligibleProductList",
					tempEligibleProductList
				);
				setEligibleProducts(tempEligibleProductList);

				getIneligibleProductList({
					ob_business_channel_id:
						eligibleProductList?.data?.ob_business_channel_id,
					ob_originator_id: eligibleProductList?.data?.ob_originator_id,
					ob_loan_id: eligibleProductList?.data?.ob_loan_id,
					searchId: eligibleProductList?.data?.searchId,
				});
			}
		} catch (err) {
			console.log("LoanPricingCard:getEligibleProductList:err", err);
			if (err?.data?.errors?.includes("locked status")) {
				handleOpenCommonErrorModal("LOAN_CURRENTLY_LOCKED", err?.data);
			} else if (err?.data?.errors?.includes("LockPending status")) {
				handleOpenCommonErrorModal("LOCK_REQUEST_ALREADY_PENDING", err?.data);
			} else if (
				err?.data?.message?.toLowerCase()?.includes("locked by another user")
			) {
				handleOpenCommonErrorModal("LOAN_CURRENTLY_LOCKED");
			} else {
				if (err?.status === 409) {
					setHeadingErrorText("Loan File in Use");
					setErrorText(
						"Please try again later as the loan is currently being accessed by the Lock Desk. If you continue to receive this message for more than 1 hour, please contact your Account Manager for assistance."
					);
				} else {
					setErrorText(
						err?.data?.message?.errors ||
							"Error fetching Relock eligible products."
					);
				}
				handleOpenCommonErrorModal("ELIGIBLE_PRODUCTS_UNAVAILABLE", err?.data);
			}
		}
	};

	const handleGetEligibleProductDetails = async (productId) => {
		console.log("160 product id:", productId);

		try {
			const eligibleProductResponse = await getEligibleProductDetails({
				ob_business_channel_id: eligibleProducts?.data?.ob_business_channel_id,
				ob_originator_id: eligibleProducts?.data?.ob_originator_id,
				ob_loan_id: eligibleProducts?.data?.ob_loan_id,
				search_id: eligibleProducts?.data?.searchId,
				product_id: productId,
			}).unwrap();

			console.log("120 eligible product details:", eligibleProductResponse);

			setEligibleProductDetails(eligibleProductResponse);
		} catch (err) {
			console.log("270 error:", err);
			handleOpenCommonErrorModal("PRODUCT_DETAILS_UNAVAILABLE", err?.data);
		}
	};

	const isAdminManagerRole = useMemo(
		() =>
			((impersonatedUser?.email === undefined ||
				impersonatedUser?.email === null) &&
				userDetails?.user_roles?.includes("admin") === true) ||
			userDetails?.user_roles?.includes("manager") ||
			userDetails?.user_roles?.includes("AM") ||
			userDetails?.user_roles?.includes("executive") ||
			userDetails?.user_roles?.includes("AE") ||
			userDetails?.user_roles?.includes("PA") ||
			userDetails?.user_roles?.includes("assistant"),
		[impersonatedUser?.email, userDetails?.user_roles]
	);

	useEffect(() => {
		console.log("545 loan email:", loanEmail);

		if (!isAdminManagerRole && loanEmail !== undefined && loanEmail !== "") {
			getEligibleProductList();
		}
	}, [loanEmail, isAdminManagerRole]);

	useEffect(() => {
		console.log("545 org loan channel:", orgLoanChannel);

		if (
			isAdminManagerRole &&
			orgLoanChannel !== undefined &&
			orgLoanChannel !== ""
		) {
			getEligibleProductList();
		}
	}, [orgLoanChannel, isAdminManagerRole]);

	const findFieldValue = (fieldValues, fieldId) => {
		return fieldValues?.find((o) => o.fieldId === fieldId)?.value;
	};

	const updateField = (fieldValues) => {
		console.log("88 field values:", fieldValues);

		setLoanProgram(findFieldValue(fieldValues, "1401"));
		const emailFromField = findFieldValue(fieldValues, "3968");
		setLoanEmail(
			emailFromField ||
				selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.email
		);
		setOrgLoanChannel(findFieldValue(fieldValues, "TPO.X14"));
		setCompensationPlan(
			fieldValues?.find((o) => o.fieldId === "LCP.X1")?.value
		);
	};

	const getFieldValues = async (loanId) => {
		console.log("135 loan id:", loanId);
		try {
			const getValues = await field({
				loan_guid: loanId,
				fields: "1401,3968,TPO.X14,LCP.X1,TPO.X62,TPO.X75",
				selectedOrganization: currentOrganization,
				userDetails: userDetails,
			}).unwrap();
			console.log("175 all fields:", getValues?.response);
			if (getValues?.response?.length > 0) {
				updateField(getValues?.response);
			}
		} catch (err) {
			console.log("584 error:", err);
		}
	};

	useEffect(() => {
		console.log("555 loan Guid:", loanGuid);

		if (
			loanGuid !== undefined &&
			loanGuid !== "" &&
			userDetails &&
			currentOrganization
		) {
			getFieldValues(loanGuid);
		}
	}, [loanGuid, currentOrganization, userDetails]);

	useEffect(() => {
		if (Object.keys(selectedRow)?.length > 0) {
			setIsPriceLoanDisabled(false);
		} else {
			setIsPriceLoanDisabled(true);
		}
	}, [selectedRow]);

	const handleSubmitApplication = async () => {
		console.log("502 params id:", params?.id);
		console.log("502 loan id:", loanGuid);

		setError("");
		handleOpenPricingModal();
	};

	const handleToggleExpand = (productId) => {
		if (expandedProduct === productId) {
			setExpandedProduct("");
		} else {
			setExpandedProduct(productId);
			handleGetEligibleProductDetails(productId);
		}
	};

	const updateFieldsAndRunPricing = async () => {
		let valuesArr = [];

		// Update Encompass field values
		if (
			(selectedUserWithLoanChannel(
				userDetails,
				impersonatedUser,
				selectedOrganization
			)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CB ||
				selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.loan_channel === LOAN_CHANNEL_CONSTANTS.WHS) &&
			compensationPlan !== ""
		) {
			valuesArr.push({ id: "LCP.X1", value: compensationPlan });

			if (compensationPlan === "Lender Paid") {
				valuesArr.push({ id: "389", value: "" });
				valuesArr.push({ id: "1620", value: "" });
			}
		}

		try {
			const updateFieldValues = await updateFields({
				loan_guid: loanGuid || params?.id,
				field_values: valuesArr,
				selectedOrganization: currentOrganization,
				userDetails: userDetails,
			}).unwrap();

			console.log(
				"LoanPricingApplication: updateFieldsAndRunPricing: updateFieldValues",
				updateFieldValues
			);

			if (
				updateFieldValues?.response === "Field values updated successfully."
			) {
				setError("");
			} else {
				console.log(
					"LoanPricingApplication: updateFieldsAndRunPricing: else err",
					updateFieldValues?.response
				);
				setError(updateFieldValues?.response);
				return;
			}
		} catch (err) {
			console.log(
				"LoanPricingApplication: updateFieldsAndRunPricing: catch err",
				err
			);
			return;
		}

		if (
			(isAdminManagerRole &&
				orgLoanChannel !== undefined &&
				orgLoanChannel !== "") ||
			(!isAdminManagerRole && loanEmail !== undefined && loanEmail !== "")
		) {
			getEligibleProductList();
		}
	};

	return (
		<Stack direction="column" className={styles.stackContainer}>
			<Stack className={styles.bodyContainer}>
				{(selectedUserWithLoanChannel(
					userDetails,
					impersonatedUser,
					selectedOrganization
				)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CB ||
					selectedUserWithLoanChannel(
						userDetails,
						impersonatedUser,
						selectedOrganization
					)?.loan_channel === LOAN_CHANNEL_CONSTANTS.WHS) && (
					<Stack direction="row" className={styles.compensationContainer}>
						<Stack direction="column">
							{/* Compensation Type */}
							{(selectedUserWithLoanChannel(
								userDetails,
								impersonatedUser,
								selectedOrganization
							)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CB ||
								selectedUserWithLoanChannel(
									userDetails,
									impersonatedUser,
									selectedOrganization
								)?.loan_channel === LOAN_CHANNEL_CONSTANTS.WHS) && (
								<Stack
									direction="column"
									className={styles.cardHeaderContainer}
								>
									<Heading5 text="Compensation Type" fontType="semibold" />
									<Body3 text="Provide details about the loan" />
									<Body2
										text={`Pricing is based on the selected Compensation Type. \nTo request different or updated compensation, please submit a change through the Change Requests tab.`}
										extraClass={styles.pricingBody}
									/>
								</Stack>
							)}

							{(selectedUserWithLoanChannel(
								userDetails,
								impersonatedUser,
								selectedOrganization
							)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CB ||
								selectedUserWithLoanChannel(
									userDetails,
									impersonatedUser,
									selectedOrganization
								)?.loan_channel === LOAN_CHANNEL_CONSTANTS.WHS) && (
								<Stack direction="row" className={styles.formContainer}>
									{/* Loan Compensation Plan */}
									<Stack direction="column" className={styles.inputContainer}>
										<InputLabel htmlFor="select-lcp">
											<Heading6
												text="Loan Compensation Plan"
												fontType="semibold"
												extraClass={styles.inputHeader}
											/>
										</InputLabel>

										<SecondarySelect
											id="select-lcp"
											displayEmpty={true}
											fullWidth={true}
											value={compensationPlan}
											handleChange={(event) =>
												setCompensationPlan(event.target.value)
											}
											options={compensationPlanOptions}
											disabled={true}
										/>
									</Stack>
								</Stack>
							)}
						</Stack>
						<PrimaryButton
							text="Run Pricing"
							disabled={false}
							onClick={updateFieldsAndRunPricing}
							extraClass={styles.pricingButton}
						/>
					</Stack>
				)}
				<Stack direction="column" className={styles.cardHeaderContainer}>
					<Tabs
						value={tabValue}
						onChange={handleChangeTab}
						aria-label="pricing tabs"
						TabIndicatorProps={{
							style: {
								backgroundColor: "#49787F",
							},
						}}
					>
						<Tab
							className={
								tabValue === 0
									? styles.tabBtnContainer + " " + styles.activeTabBtnContainer
									: styles.tabBtnContainer
							}
							label={
								<Stack direction="row" className={styles.tabLabelContainer}>
									<Heading6
										text={`Eligible Pricing Results (${
											eligibleProducts?.data?.products
												? eligibleProducts?.data?.products?.length
												: 0
										})`}
										fontType="semibold"
										extraClass={
											tabValue === 0 ? styles.activeTabText : styles.tabText
										}
									/>
								</Stack>
							}
							{...a11yProps(0)}
						/>
						<Tab
							className={
								tabValue === 1
									? styles.tabBtnContainer + " " + styles.activeTabBtnContainer
									: styles.tabBtnContainer
							}
							label={
								<Stack direction="row" className={styles.tabLabelContainer}>
									<Heading6
										text={`Ineligible Pricing Results (${
											ineligibleProducts ? ineligibleProducts?.length : 0
										})`}
										fontType="semibold"
										extraClass={
											tabValue === 1 ? styles.activeTabText : styles.tabText
										}
									/>
								</Stack>
							}
							{...a11yProps(1)}
						/>
					</Tabs>
				</Stack>

				<TabPanel
					index={0}
					value={tabValue}
					className={tabValue === 0 ? styles.tabPanelContainer : ""}
				>
					{eligibleProducts?.data?.products?.length > 0 ? (
						<EligibleFilter
							eligibleProducts={eligibleProducts?.data?.products}
							expandedProduct={expandedProduct}
							toggleExpand={handleToggleExpand}
							eligibleProductDetails={eligibleProductDetails?.data}
							selectedRow={selectedRow}
							setSelectedRow={setSelectedRow}
							setSelectedProduct={setSelectedProduct}
							toggleDrawer={toggleDrawer}
							hidePriceColumn={
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === TPO_SECONDARY ||
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === BROKER_ADMIN
									? false
									: selectedUserWithLoanChannel(
											userDetails,
											impersonatedUser,
											selectedOrganization
										)?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
										selectedUserWithLoanChannel(
											userDetails,
											impersonatedUser,
											selectedOrganization
										)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
							}
							hidePointsPercentageColumn={
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === TPO_SECONDARY
									? false
									: selectedUserWithLoanChannel(
											userDetails,
											impersonatedUser,
											selectedOrganization
										)?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
										selectedUserWithLoanChannel(
											userDetails,
											impersonatedUser,
											selectedOrganization
										)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
							}
							hidePointsValueColumn={
								selectedUserWithAccessLevel(userDetails, impersonatedUser)
									?.access_level === TPO_SECONDARY
									? false
									: selectedUserWithLoanChannel(
											userDetails,
											impersonatedUser,
											selectedOrganization
										)?.loan_channel === LOAN_CHANNEL_CONSTANTS.NDC ||
										selectedUserWithLoanChannel(
											userDetails,
											impersonatedUser,
											selectedOrganization
										)?.loan_channel === LOAN_CHANNEL_CONSTANTS.CORR
							}
							hideEligibleProductFilters={true}
						/>
					) : (
						<EmptyTextContainer
							headerText="No products available"
							bodyText={`Please click the Ineligible button above to see why no products are available`}
						/>
					)}
				</TabPanel>

				<TabPanel
					index={1}
					value={tabValue}
					className={tabValue === 1 ? styles.tabPanelContainer : ""}
				>
					{ineligibleProducts?.length > 0 ? (
						<IneligibleFilter ineligibleProducts={ineligibleProducts || []} />
					) : (
						<EmptyTextContainer
							headerText="No products available"
							bodyText={`There are no Ineligible products available for this loan`}
						/>
					)}
				</TabPanel>
			</Stack>

			{/* loan flow error */}
			{error !== "" && (
				<RequiredError
					headerText="Missing fields"
					text={
						error.includes("Something went wrong")
							? "Updates Not Received by LOS. Please Try Again."
							: error.includes("provide a value")
								? "Please provide a value for all fields highlighted above."
								: error
					}
				/>
			)}

			{/* drawer */}
			<TemporaryDrawer
				// drawer props
				drawerOpen={drawerOpen}
				drawerDirection="right"
				drawerType={drawerType}
				toggleDrawer={toggleDrawer}
				handleCloseDrawer={handleCloseDrawer}
				handleOpenProcessingModal={handleOpenProcessingModal}
				handleCloseProcessingModal={handleCloseProcessingModal}
				setProcessingText={setProcessingText}
				handleOpenSuccessModal={handleOpenSuccessModal}
				setSuccessText={setSuccessText}
				handleOpenCommonErrorModal={handleOpenCommonErrorModal}
				// custom props
				drawerData={drawerData}
			/>
			{/* custom modals */}
			<LoaderTextModal
				open={
					isGettingLoan ||
					isGettingEligibleProducts ||
					isGettingEligibleProductDetails ||
					isGettingIneligibleProducts
				}
				loadingTextLine1={"Obtaining Pricing & Eligibility"}
				loadingTextLine2={"This will take a few minutes"}
			/>
			<LoaderTextModal
				open={isCreatingOBLockRequest || isUpdatingLoanWithProduct}
				loadingTextLine1={"Submitting your Lock Request"}
				loadingTextLine2={"This will take a few minutes"}
			/>
			<LoaderModal open={isUpdatingFields} />
			<ProcessingModal open={processingModalVisible} text={processingText} />
			<SuccessModal
				open={successModalVisible}
				handleClose={handleCloseSuccessModal}
				text={successText}
			/>
			<ErrorModal
				open={errorModalVisible}
				text={errorText}
				title={errorHeadingText}
				handleClose={handleCloseErrorModal}
			/>
			<CommanErrorModal
				isOpen={commonErrorModalVisible}
				onClose={handleCloseCommonErrorModal}
				title={commonErrorData?.title}
				message={commonErrorData?.message}
				errorKey={commonErrorData?.error_key}
				errorCode={commonErrorData?.code}
				errorResponse={commonErrorData?.error_response}
			/>
			<PricingModal
				open={pricingModal}
				data={selectedRow}
				productName={selectedProduct}
				confirmText="Request Rate Lock"
				handleConfirm={handleSubmitPricingModal}
				closeText="Go back"
				handleClose={handleClosePricingModal}
			/>
		</Stack>
	);
};

export default React.forwardRef(LoanPricingCard);
